import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

import React from 'react';
import cx from 'classnames';

const styles = theme => ({
  detailRow: {
    paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  left: {
    flex: '1 0 auto',
  },
  right: {
    marginRight: theme.spacing(2),
  },
  padding: {
    padding: theme.spacing(2),
  },
  value: {
    verticalAlign: 'middle',
  },
  noPadding: {
    paddingBottom: 0,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
});
const ArchDetailRow = withStyles(
  ({ classes, label, value, rightHand, padding, noPadding, flex }) => (
    <div
      className={cx(
        classes.detailRow,
        padding && classes.padding,
        noPadding && classes.noPadding,
      )}
    >
      <div className={rightHand && classes.left}>
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
        <Typography
          variant="body2"
          className={cx(classes.value, flex && classes.flex)}
        >
          {value}
        </Typography>
      </div>

      {rightHand && <div className={classes.right}>{rightHand}</div>}
    </div>
  ),
  styles,
);

export default ArchDetailRow;
